t = require('views/internal/teacup-with-helpers')('member_profile')

module.exports = ->
  t.div '.window-module', ->

    t.div '.window-module-title', ->
      t.span '.window-module-title-icon.icon-lg.icon-organization'
      t.h3 ->
        t.format 'organizations'

    t.div '.u-gutter.js-list-orgs'

  t.div '.window-module', ->

    t.div '.window-module-title', ->
      t.span '.window-module-title-icon.icon-lg.icon-activity'
      t.h3 ->
        t.format 'activity'

    t.div '.list-actions'

    t.p '.u-bottom', ->
      t.a '.show-more.js-more-actions', { href: '#' }, ->
        t.format 'load-more-activity'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_profile.coffee